import { BehaviorType } from "../types";
import Behavior from "../types/Behavior";
class ContextMenuBehavior extends Behavior {
    constructor(plasm, appName, addMetadata) {
        super(plasm, appName, addMetadata);
        this.id = BehaviorType.contextmenu;
        this.handler = (event) => this.onContextMenu(event);
        this.iframeBehaviorListeners = [{ type: this.id, listener: this.handler }];
    }
    onContextMenu(event) {
        if (this.addMetadata != null) {
            const eventMeta = this.addMetadata(event);
            const { questionId } = eventMeta;
            if (questionId != null) {
                setTimeout(() => {
                    this.captureScreenshot({ trigger: "question-selection-context-menu-called" });
                }, 200);
            }
        }
        this.addLog(event, this.id);
    }
}
export default ContextMenuBehavior;
